import { render, staticRenderFns } from "./pie.vue?vue&type=template&id=5aea5588&"
import script from "./pie.vue?vue&type=script&lang=js&"
export * from "./pie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports